hrd.dashboard.runPostLoad = function() {
	const tooltipDelay = 2000;
	$('.ui-button:disabled').removeProp('disabled');
	$('button').prop('type', 'button');
	$('.ui-button').tooltip({
		track: false,
		open: function(event, ui) {
			$.timeout(tooltipDelay).then(() => {
				$(ui.tooltip).hide();
			});
		}
	});
}